import { Link } from 'react-router-dom';
import { FASH_LOGO } from '../../constants/brand';
import { ROUTES } from '../../constants/routes';

interface ShopperFooterProps {
  className?: string;
}

export function ShopperFooter({ className = '' }: ShopperFooterProps) {
  return (
    <footer className={`bg-gray-50 border-t border-gray-100 py-8 md:py-12 ${className}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-6 md:gap-8">
          <div>
            <img src={FASH_LOGO} alt="Fash" className="h-14 md:h-20 object-contain mb-3 md:mb-4" />
            <p className="text-sm text-body">Premium fashion, delivered today.</p>
          </div>
          <div>
            <h5 className="font-medium text-heading mb-2 md:mb-3 text-sm md:text-base">Shop</h5>
            <ul className="space-y-1.5 md:space-y-2 text-sm text-body">
              <li>
                <Link to={ROUTES.boutiques} className="hover:text-primary">
                  Boutiques
                </Link>
              </li>
              <li>
                <Link to={ROUTES.categories} className="hover:text-primary">
                  Categories
                </Link>
              </li>
              <li>
                <Link to={ROUTES.sale} className="hover:text-primary">
                  Sale
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h5 className="font-medium text-heading mb-2 md:mb-3 text-sm md:text-base">Help</h5>
            <ul className="space-y-1.5 md:space-y-2 text-sm text-body">
              <li>
                <Link to={ROUTES.faq} className="hover:text-primary">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to={ROUTES.shipping} className="hover:text-primary">
                  Shipping
                </Link>
              </li>
              <li>
                <Link to={ROUTES.returns} className="hover:text-primary">
                  Returns
                </Link>
              </li>
              <li>
                <Link to={ROUTES.contact} className="hover:text-primary">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h5 className="font-medium text-heading mb-2 md:mb-3 text-sm md:text-base">Company</h5>
            <ul className="space-y-1.5 md:space-y-2 text-sm text-body">
              <li>
                <Link to={ROUTES.about} className="hover:text-primary">
                  About
                </Link>
              </li>
              <li>
                <Link to={ROUTES.careers} className="hover:text-primary">
                  Careers
                </Link>
              </li>
              <li>
                <Link to={ROUTES.press} className="hover:text-primary">
                  Press
                </Link>
              </li>
              <li>
                <Link to={ROUTES.blog} className="hover:text-primary">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-6 md:mt-8 pt-6 md:pt-8 text-center text-sm text-body">
          © 2026 Fash. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
